<template>
  <div id="login-container">
    <div class="login-fields">
      <span>Username</span>
      <input v-model="fields.username" type="text" placeholder="username" />
      <span>Password</span>
      <input v-model="fields.password" type="password" placeholder="password" />
      <button @click="login()">Log in</button>

      <div class="divider"></div>
      <button @click="loginSewist()">Sewist Entry Point</button>
      <button>
        <router-link :to="'/ppeform'">Request PPE</router-link>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import fire from "@/config/fire.js";
import axios from "axios";
import firebase from "firebase";
export default {
  name: "Login",

  computed: {
    ...mapState(["global"])
  },
  data() {
    return {
      fields: {
        username: "",
        password: ""
      },
      errors: {}
    };
  },
  mounted() {
    this.authListener();
  },
  methods: {
    loginSewist() {
      //this method exists in two places. if further complexity is added. refactor to controller structure
      const url = process.env.VUE_APP_BASE_URL + "/api/sewistData";
      axios({
        method: "get",
        url: url
      }).then(res => {
        if (res && res.data) {
          this.setUserDataAndType({
            accountType: "sewist",
            userData: { sortedRequests: res.data.sortedRequests }
          });
          this.setTotalStats(res.data.totalStats);
        }
      });
    },
    login() {
      const username = this.fields.username;
      const password = this.fields.password;
      fire
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .then(() => {
          // Existing and future Auth states are now persisted in the current
          // session only. Closing the window would clear any existing state even
          // if a user forgets to sign out.
          // ...
          // New sign-in will be persisted with session persistence.
          fire
            .auth()
            .signInWithEmailAndPassword(username, password)
            .then(user => {
              this.fields = {
                username: "",
                password: ""
              };
              this.$swal("Login Success!", "Login Success!", "success");
              this.setLoggedIn(true);
            })
            .catch(err => {
              this.$swal(
                "Incorrect Email or Password",
                "Please try again",
                "error"
              );
            });
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
        });
    },

    logout() {
      fire.auth().signOut();
    },
    authListener() {
      fire.auth().onAuthStateChanged(user => {
        this.loggedIn = user != null;
        if (user) {
          this.setLoggedIn(true);
        }
      });
    },
    ...mapActions(["setLoggedIn", "setUserDataAndType", "setTotalStats"])
  }
};
</script>

<style lang="scss" scoped>
#login-container {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background: linear-gradient(to right, rgb(32, 53, 109), rgb(216, 60, 180));

  .login-fields {
    padding: 30px 21.5px 30px 20px;
    width: 282px;
    max-width: 100vw;
    display: flex;
    flex-direction: column;
    background: rgba(16, 29, 59, 0.15);
    border-radius: 2.02px;
    border-radius: 2.02px;
    span {
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      margin-bottom: 12px;
    }
    input {
      height: 39px;
      background: rgba(16, 29, 59, 0.3);
      border: 1px solid #ffffff;
      border-radius: 2.02px;
      border-radius: 2.02px;
      margin-bottom: 20px;
      color: #fff;
      padding-left: 8px;
    }
    button {
      height: 39px;
      background: #ffffff;
      border-radius: 2.02px;
      border-radius: 2.02px;
    }
    .divider {
      height: 1px;
      background: rgba(228, 63, 189, 0.797);
      width: 100%;
      margin: 16px 0;
    }
  }
}
</style>